import Imgix, { buildURL, SharedImgixAndSourceProps } from 'react-imgix';
import { imgixUrl } from 'src/utils/images';

export const Image: React.FC<SharedImgixAndSourceProps> = ({
  src,
  imgixParams,
  ...props
}) => {
  const imgixSrc = imgixUrl(src);
  imgixParams = { auto: 'compress,format', ...imgixParams };
  if (!imgixSrc) return null;
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'ImageObject',
          contentUrl: imgixSrc,
          thumbnailUrl: buildURL(imgixSrc, { w: 256, h: 256 }),
        })}
      </script>
      <Imgix src={imgixSrc} imgixParams={imgixParams} {...props} />
    </>
  );
};
